import { Box } from '@mantine/core';
import { UsersTable } from './users/components/UsersTable';
import { AdminTabs, useAdminTabs } from './hooks/useAdminTabs';
import { useMemo } from 'react';
import { Navigate } from 'react-router';
import UnderlineTabsDeprecated from 'src/UI/page-nav/UnderlineTabsDeprecated';
import DataExportConfigPage from 'src/company/data-export-config/DataExportConfigPage';
import ManageSiestaSkillsPage from './manage-siesta-skills/ManageSiestaSkillsPage';
import SkillLibraryPage from './skill-library/SkillLibraryPage';
import DevToolsPage from './dev-tools/DevToolsPage';
import useCurrentUser from './users/hooks/useCurrentUser';
import { useFlags } from 'src/feature-flags/FlagsHook';

export default function AdminPage() {
  const { currentTab, setTab } = useAdminTabs();
  const { flagEnabledAdminAdviserSignatures, flagEnabledSkillLibrary } = useFlags();
  const { isSystemAdmin, isServiceAdmin } = useCurrentUser();

  const tabContent = useMemo(() => {
    if (currentTab === AdminTabs.Users) {
      return <UsersTable />;
    }

    if (currentTab === AdminTabs.Appearance) {
      return <Box>Appearance settings will be here.</Box>;
    }
  }, [currentTab]);

  // Service admins are only admitted to manage adviser signatures from the users table
  if (!isSystemAdmin) {
    if (!isServiceAdmin || !flagEnabledAdminAdviserSignatures) {
      return <Navigate to="/" replace />;
    }
    if (currentTab !== AdminTabs.Users) {
      return <Navigate to={`/admin/${AdminTabs.Users}`} replace />;
    }
  }

  if (currentTab === AdminTabs.DataExportConfig) {
    return (
      <Box p="md">
        <DataExportConfigPage />
      </Box>
    );
  }

  if (currentTab === AdminTabs.ManageSiestaSkills) {
    return (
      <Box p="md">
        {flagEnabledSkillLibrary ? <SkillLibraryPage /> : <ManageSiestaSkillsPage />}
      </Box>
    );
  }

  if (currentTab === AdminTabs.DevTools) {
    return <DevToolsPage />;
  }

  return (
    <Box p="md">
      <UnderlineTabsDeprecated
        value={currentTab}
        onChange={value => {
          if (value != null) {
            setTab(value as AdminTabs);
          }
        }}
      >
        <UnderlineTabsDeprecated.List>
          <UnderlineTabsDeprecated.Tab value={AdminTabs.Users}>Users</UnderlineTabsDeprecated.Tab>
        </UnderlineTabsDeprecated.List>

        <Box mt="sm">{tabContent}</Box>
      </UnderlineTabsDeprecated>
    </Box>
  );
}
